import { withTheme } from 'theme';
import material3 from 'theme/material3';

const getContainer = (selected: boolean) => withTheme((theme) => ({
  minWidth: '132px',
  background: selected ? material3.color.primaryLight : 'transparent',
  border: `1px solid ${selected ? material3.color.primary : material3.color.outline}`,
  borderRadius: material3.shape.medium,
  boxShadow: material3.elevation.level0,
  paddingY: theme.spacing(1),
  paddingX: theme.spacing(1.5),
  color: selected ? material3.color.primaryDark : material3.color.textSecondary,
  transition: 'background .18s ease, border-color .18s ease',
  '&:hover': {
    background: selected ? material3.color.primaryLight : material3.color.surfaceContainer,
    borderColor: material3.color.primary,
    cursor: 'pointer'
  },
  '& .MuiCheckbox-root': {
    color: selected ? material3.color.primaryDark : material3.color.primary,
    padding: '0px'
  },
  '& .MuiTypography-root': {
    color: selected ? material3.color.primaryDark : material3.color.textSecondary,
    fontWeight: material3.typography.labelWeight
  }
}));

const styles = {
  getContainer
};

export default styles;
